export default __webpack_public_path__ + "static/media/prefImage.3834172a.png";